module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-social-banners-1200x630-e46ce4b478c5e1b4f71043e11611262a.jpg";